const FreemiumChargeSuccess = ({
  activeProductType = -1,
  expirationDateTimestamp = '',
  isPaymentValid = false,
  paymentStatus = '',
} = {}) => ({
  activeProductType: Number(activeProductType),
  expirationDateTimestamp: String(expirationDateTimestamp),
  isPaymentValid: Boolean(isPaymentValid),
  paymentStatus: String(paymentStatus),
});

export default FreemiumChargeSuccess;

export type FreemiumChargeSuccessProps = ReturnType<typeof FreemiumChargeSuccess>;
